module.exports = __webpack_public_path__ + "static/media/DaysOff3.bc0da7ca.png";